import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "../fonts/breuer-headline.css";
import "./sorthat.css";
import { setBackButtonUrl } from "../uiSlice";
import hatGif from "../images/hat.gif";
import sortingHatPng from "../images/sortingHat.png";
import { pickRandomHouse } from "../house/housesConfig";

const SORT_REVEAL_MS = 1600;
const HOGWARTS_SELECTION_KEY_BASE = "hogwartsSelectionData";

function readStoredUserData() {
  try {
    const raw =
      localStorage.getItem("userData") ||
      sessionStorage.getItem("userData") ||
      "{}";
    return JSON.parse(raw) || {};
  } catch {
    return {};
  }
}

function getSelectionStorageKey(userLike) {
  const stored = readStoredUserData();
  const uid = userLike?.userId ?? userLike?.userid ?? userLike?.id ?? stored?.userId ?? stored?.userid ?? stored?.id;
  const sid = userLike?.sessionId ?? stored?.sessionId;
  const oid = userLike?.organizationId ?? stored?.organizationId;
  const scope = [uid, sid, oid]
    .map((v) => String(v ?? "").trim())
    .join(":");
  return scope.replace(/:/g, "") ? `${HOGWARTS_SELECTION_KEY_BASE}:${scope}` : HOGWARTS_SELECTION_KEY_BASE;
}

function readSelectionArray(userLike) {
  try {
    const raw = localStorage.getItem(getSelectionStorageKey(userLike));
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function upsertSelectionEntry(type, value, userLike) {
  const current = readSelectionArray(userLike);
  const filtered = current.filter((item) => item?.type !== type);
  filtered.push({ type, ...value });
  try {
    localStorage.setItem(getSelectionStorageKey(userLike), JSON.stringify(filtered));
  } catch {
    // ignore storage write failures
  }
}

function findSelectionEntry(type, userLike) {
  return readSelectionArray(userLike).find((item) => item?.type === type) ?? null;
}

function SortHat() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { status, user } = useSelector((state) => state.auth);
  const [revealed, setRevealed] = useState(false);
  const navigateTimerRef = useRef(null);

  useEffect(() => {
    document.documentElement.classList.add("sorthat-static-bg");
    document.body.classList.add("sorthat-static-bg");
    return () => {
      document.documentElement.classList.remove("sorthat-static-bg");
      document.body.classList.remove("sorthat-static-bg");
    };
  }, []);

  useEffect(() => {
    dispatch(setBackButtonUrl("/rules"));
  }, [dispatch, status, user]);

  useEffect(() => {
    return () => {
      if (navigateTimerRef.current) {
        clearTimeout(navigateTimerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const existingHouse = findSelectionEntry("house", user);
    if (existingHouse?.houseId) {
      navigate("/house", { state: { houseId: existingHouse.houseId }, replace: true });
    }
  }, [navigate, user]);

  const handleHatClick = () => {
    if (revealed) return;
    setRevealed(true);
    const chosen = pickRandomHouse();
    upsertSelectionEntry("house", {
      houseId: chosen.id,
      houseName: chosen.name,
    }, user);
    // Reset downstream choices for a new sorting decision.
    try {
      const reset = readSelectionArray(user).filter(
        (item) => item?.type === "house"
      );
      localStorage.setItem(getSelectionStorageKey(user), JSON.stringify(reset));
    } catch {
      // ignore storage write failures
    }
    navigateTimerRef.current = setTimeout(() => {
      navigate("/house", { state: { houseId: chosen.id }, replace: false });
    }, SORT_REVEAL_MS);
  };

  return (
    <div className="sorthat-page">
      <div className="sorthat-stack">
        <div className="sorthat-hat-wrap">
          <div className="sorthat-hat-thoughts" role="note">
          <p className="sorthat-hat-thoughts-line">Tap the Sorting Hat to be assigned a random Hogwarts house
          </p>
            <p className="sorthat-hat-thoughts-line">
              Hmm… difficult. Very difficult…
            </p>
            <p className="sorthat-hat-thoughts-line">
              I see magic within you, better be...
            </p>
          </div>
          <button
            type="button"
            className="sorthat-hat-trigger"
            onClick={handleHatClick}
            disabled={revealed}
            aria-label={
              revealed
                ? "Sorting in progress"
                : "Tap the Sorting Hat to be sorted"
            }
          >
            <img
              src={revealed ? sortingHatPng : hatGif}
              className="sorthat-hat"
              alt="The Sorting Hat"
            />
          </button>
        </div>
        {/* <button
          type="button"
          className="sorthat-start-btn"
          onClick={handleContinueClick}
        >
          <img src={startBtnImg} alt="Continue to game" />
        </button> */}
      </div>
    </div>
  );
}

export default SortHat;
